const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/WunschleistungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const WunschleistungField = generateMetaKatDropDownField(
    '484d0af1-cae8-4c6f-9cda-90556dd683a3',
    'WunschleistungField'
);

export default WunschleistungField;
